import React, { useState, useRef, useEffect } from 'react';
import axios from '../../api/AxiosInstance';
import { useParams } from 'react-router-dom';
import { Layout } from 'antd'
import config from '../../config';

const { Content } = Layout;

export const ImpersonateProvider = () => {
  const [impersonatedDetails, setImpersonatedDetails] = useState(null);
  const [iframeLoaded, setIframeLoaded] = useState(false);
  const { providerId } = useParams();
  const iframeRef = useRef(null);

  useEffect(() => {
    axios.post(`/auth/impersonate/${providerId}`)
        .then(res => {
            setImpersonatedDetails(res.data.payload);
        })
  }, [])

  useEffect(() => {
    if (iframeLoaded) {
      iframeRef.current.contentWindow.postMessage({ action: 'start', payload: impersonatedDetails }, config.providerClientUrl);
    }
  }, [iframeLoaded])

  if (!impersonatedDetails) return 'generating token for user to impersonate...';

  return (
    <Content>
        <iframe 
        ref={iframeRef}
        src={config.providerClientUrl}
        width='100%'
        style={{ height: '90vh' }}
        onLoad={() => setIframeLoaded(true)}
        />
    </Content>
  );
}